import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabaseProjectHost = (() => {
  try {
    return new URL(supabaseUrl).host;
  } catch (_error) {
    return 'invalid-supabase-url';
  }
})();

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

if (typeof window !== 'undefined') {
  // eslint-disable-next-line no-console
  console.info('[SUPABASE] client_init', {
    projectHost: supabaseProjectHost,
    hasUrl: Boolean(supabaseUrl),
    hasAnonKey: Boolean(supabaseAnonKey),
  });
}
